import { render, staticRenderFns } from "./PageSidebar.vue?vue&type=template&id=10278d14&scoped=true&"
import script from "./PageSidebar.vue?vue&type=script&lang=js&"
export * from "./PageSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PageSidebar.vue?vue&type=style&index=0&id=10278d14&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10278d14",
  null
  
)

export default component.exports